import React from "react";
import { Provider, connect } from "react-redux";
import { applyMiddleware, compose } from "redux";
import { legacy_createStore as createStore } from 'redux';
import thunk from "redux-thunk";
import reducers from "./reducers";
import ReactDOM from "react-dom/client";
import { getUser } from 'actions';

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/pagination.css";
import "./assets/css/demo.css";

import Admin from "layouts/Admin.js";
import LoginForm from "components/LoginForm";
import SetPassword from "views/Auth/SetPassword";
import TKT1Landing from "views/TKT1Landing";
import { USER_GROUPS } from './routes';
import { isTKT1Landing, getPlatformDisplayName, getCurrentPlatform } from './utils/platform';

const root = ReactDOM.createRoot(document.getElementById("root"));

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = composeEnhancers(applyMiddleware(thunk))(createStore)(reducers);

window.store = store;

const viewSoldChart = window.location.hostname.includes("resin");

const App = (props) => {
  React.useEffect(() => {
    props.getUser();
    
    // Cập nhật title và favicon dựa trên platform
    document.title = getPlatformDisplayName();
    
    // Thay đổi favicon dựa trên platform
    const favicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    if (favicon) {
      const platform = getCurrentPlatform();
      if (platform === 'TKT1-landing' || platform === 'TKT1-app') {
        favicon.href = '/TKT1_favicon3.png';
      } else {
        favicon.href = '/favicon4.png'; // Favicon mặc định cho TKT1
      }
    } else {
      // Tạo favicon link nếu chưa có
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      const platform = getCurrentPlatform();
      newFavicon.href = (platform === 'TKT1-landing' || platform === 'TKT1-app') ? '/TKT1_favicon3.png' : '/favicon4.png';
      document.head.appendChild(newFavicon);
    }
  }, []);

  // Nếu là TKT1 landing page
  if (isTKT1Landing()) {
    console.log('🎯 TKT1 landing detected, showing landing page');
    return <TKT1Landing />;
  }

      // Nếu là TKT1 app
  console.log('🏪 App detected, showing application');

  if (!props.user) {
    return <LoginForm />;
  }

  // If user needs to change password, show SetPassword component
  if (props.user.status === 'NEED_CHANGE_PASSWORD') {
    return <SetPassword />;
  }

  // Get default route based on user's first group
  const getDefaultRoute = () => {
    const userGroups = props.user.group_ids || [];
    if (userGroups.includes(USER_GROUPS.RND)) {
      return '/admin/rnd/product-rnd-list';
    } else if (userGroups.includes(USER_GROUPS.SALE)) {
      return '/admin/sale/orders';
    } else if (userGroups.includes(USER_GROUPS.FULFILL)) {
      return '/admin/fulfill/orders';
    }
    // Default route for other roles
    return '/admin/tkt1/trusted-person';
  };

  return (
    <Switch>
      <Route path="/admin" render={(props) => <Admin {...props} />} />
      <Redirect from="/" to={getDefaultRoute()} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  user: state.authenReducer.user
});

const ConnectedApp = connect(mapStateToProps, { getUser })(App);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConnectedApp />
    </BrowserRouter>
  </Provider>
);
